import { Siren } from "lucide-react";
import React, { useEffect } from "react";
import { useAdminData } from "../hooks";
import { useAdminContext } from "../context";
export type FundingHealth = Readonly<{ status: string; observedAt?: string; pools: readonly { pool: string; status: string; note?: string; issues: readonly string[]; heartbeat?: { successAt?: string } | null }[] }>;
export function FundingHealthBanner() {
  const { navigate } = useAdminContext();
  const state = useAdminData<FundingHealth>("/admin/funding-health");
  useEffect(() => { const timer = setInterval(state.reload, 60_000); return () => clearInterval(timer); }, []);
  if (state.loading && !state.envelope && !state.error) return null;
  if (!state.error && state.envelope?.data.status === "HEALTHY") return null;
  return <section className="funding-alarm" role="alert"><Siren aria-hidden="true" /><div><strong>Prize funding needs attention</strong>
    {state.error ? <p>Funding health could not be verified. Treat PP and VP funding as unknown until checks recover.</p>
      : <p>{state.envelope?.data.pools.filter(pool => pool.status !== "HEALTHY").map(pool => `${pool.pool}: ${pool.issues.join(" ")}`).join(" ") ?? "Funding health is unavailable."}</p>}
    <button className="button secondary" onClick={() => navigate("/purse-sponsorship")}>Inspect prize funding</button></div></section>;
}
